import { render } from "./SmsTemplate.vue?vue&type=template&id=5a06ad2b&scoped=true&ts=true"
import script from "./SmsTemplate.vue?vue&type=script&lang=ts"
export * from "./SmsTemplate.vue?vue&type=script&lang=ts"

import "./SmsTemplate.vue?vue&type=style&index=0&id=5a06ad2b&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a06ad2b"]])

export default __exports__